module.exports = __webpack_public_path__ + "img/midea-logo.52548407.png";